
var Rive = (() => {
  var _scriptName = typeof document != 'undefined' ? document.currentScript?.src : undefined;
  
  return (
function(moduleArg = {}) {
  var moduleRtn;

var k = moduleArg, aa, ba, da = new Promise((b, a) => {
  aa = b;
  ba = a;
}), ea = "object" == typeof window, fa = "function" == typeof importScripts;
function ka() {
  function b(m) {
    const h = d;
    c = a = 0;
    d = new Map();
    h.forEach(l => {
      try {
        l(m);
      } catch (n) {
        console.error(n);
      }
    });
    this.va();
    e && e.Pa();
  }
  let a = 0, c = 0, d = new Map(), e = null, f = null;
  this.requestAnimationFrame = function(m) {
    a ||= requestAnimationFrame(b.bind(this));
    const h = ++c;
    d.set(h, m);
    return h;
  };
  this.cancelAnimationFrame = function(m) {
    d.delete(m);
    a && 0 == d.size && (cancelAnimationFrame(a), a = 0);
  };
  this.Na = function(m) {
    f && (document.body.remove(f), f = null);
    m || (f = document.createElement("div"), f.style.backgroundColor = "black", f.style.position = "fixed", f.style.right = 0, f.style.top = 0, f.style.color = "white", f.style.padding = "4px", f.innerHTML = "RIVE FPS", m = function(h) {
      f.innerHTML = "RIVE FPS " + h.toFixed(1);
    }, document.body.appendChild(f));
    e = new function() {
      let h = 0, l = 0;
      this.Pa = function() {
        var n = performance.now();
        l ? (++h, n -= l, 1000 < n && (m(1000 * h / n), h = l = 0)) : (l = n, h = 0);
      };
    }();
  };
  this.Ka = function() {
    f && (document.body.remove(f), f = null);
    e = null;
  };
  this.va = function() {
  };
}
function la(b) {
  console.assert(!0);
  const a = new Map();
  let c = -Infinity;
  this.push = function(d) {
    d = d + ((1 << b) - 1) >> b;
    a.has(d) && clearTimeout(a.get(d));
    a.set(d, setTimeout(function() {
      a.delete(d);
      0 == a.length ? c = -Infinity : d == c && (c = Math.max(...a.keys()), console.assert(c < d));
    }, 1000));
    c = Math.max(d, c);
    return c << b;
  };
}
const ma = k.onRuntimeInitialized;
k.onRuntimeInitialized = function() {
  ma && ma();
  let b = k.decodeAudio;
  k.decodeAudio = function(e, f) {
    e = b(e);
    f(e);
  };
  let a = k.decodeFont;
  k.decodeFont = function(e, f) {
    e = a(e);
    f(e);
  };
  const c = k.FileAssetLoader;
  k.ptrToAsset = e => {
    let f = k.ptrToFileAsset(e);
    return f.isImage ? k.ptrToImageAsset(e) : f.isFont ? k.ptrToFontAsset(e) : f.isAudio ? k.ptrToAudioAsset(e) : f;
  };
  k.CustomFileAssetLoader = c.extend("CustomFileAssetLoader", {__construct:function({loadContents:e}) {
    this.__parent.__construct.call(this);
    this.Ea = e;
  }, loadContents:function(e, f) {
    e = k.ptrToAsset(e);
    return this.Ea(e, f);
  },});
  k.CDNFileAssetLoader = c.extend("CDNFileAssetLoader", {__construct:function() {
    this.__parent.__construct.call(this);
  }, loadContents:function(e) {
    let f = k.ptrToAsset(e);
    e = f.cdnUuid;
    if ("" === e) {
      return !1;
    }
    (function(m, h) {
      var l = new XMLHttpRequest();
      l.responseType = "arraybuffer";
      l.onreadystatechange = function() {
        4 == l.readyState && 200 == l.status && h(l);
      };
      l.open("GET", m, !0);
      l.send(null);
    })(f.cdnBaseUrl + "/" + e, m => {
      f.decode(new Uint8Array(m.response));
    });
    return !0;
  },});
  k.FallbackFileAssetLoader = c.extend("FallbackFileAssetLoader", {__construct:function() {
    this.__parent.__construct.call(this);
    this.ua = [];
  }, addLoader:function(e) {
    this.ua.push(e);
  }, loadContents:function(e, f) {
    for (let m of this.ua) {
      if (m.loadContents(e, f)) {
        return !0;
      }
    }
    return !1;
  },});
  let d = k.computeAlignment;
  k.computeAlignment = function(e, f, m, h, l = 1.0) {
    return d.call(this, e, f, m, h, l);
  };
};
const pa = "createConicGradient createImageData createLinearGradient createPattern createRadialGradient getContextAttributes getImageData getLineDash getTransform isContextLost isPointInPath isPointInStroke measureText".split(" "), qa = new function() {
  function b() {
    if (!a) {
      var g = document.createElement("canvas"), t = {alpha:1, depth:0, stencil:0, antialias:0, premultipliedAlpha:1, preserveDrawingBuffer:0, powerPreference:"high-performance", failIfMajorPerformanceCaveat:0, enableExtensionsByDefault:1, explicitSwapControl:1, renderViaOffscreenBackBuffer:1,};
      let q;
      if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
        if (q = g.getContext("webgl", t), c = 1, !q) {
          return console.log("No WebGL support. Image mesh will not be drawn."), !1;
        }
      } else {
        if (q = g.getContext("webgl2", t)) {
          c = 2;
        } else {
          if (q = g.getContext("webgl", t)) {
            c = 1;
          } else {
            return console.log("No WebGL support. Image mesh will not be drawn."), !1;
          }
        }
      }
      q = new Proxy(q, {get(F, v) {
        if (F.isContextLost()) {
          if (l || (console.error("Cannot render the mesh because the GL Context was lost. Tried to invoke ", v), l = !0), "function" === typeof F[v]) {
            return function() {
            };
          }
        } else {
          return "function" === typeof F[v] ? function(...H) {
            return F[v].apply(F, H);
          } : F[v];
        }
      }, set(F, v, H) {
        if (F.isContextLost()) {
          l || (console.error("Cannot render the mesh because the GL Context was lost. Tried to set property " + v), l = !0);
        } else {
          return F[v] = H, !0;
        }
      },});
      d = Math.min(q.getParameter(q.MAX_RENDERBUFFER_SIZE), q.getParameter(q.MAX_TEXTURE_SIZE));
      function G(F, v, H) {
        v = q.createShader(v);
        q.shaderSource(v, H);
        q.compileShader(v);
        H = q.getShaderInfoLog(v);
        if (0 < (H || "").length) {
          throw H;
        }
        q.attachShader(F, v);
      }
      g = q.createProgram();
      G(g, q.VERTEX_SHADER, "attribute vec2 vertex;\n                attribute vec2 uv;\n                uniform vec4 mat;\n                uniform vec2 translate;\n                varying vec2 st;\n                void main() {\n                    st = uv;\n                    gl_Position = vec4(mat2(mat) * vertex + translate, 0, 1);\n                }");
      G(g, q.FRAGMENT_SHADER, "precision highp float;\n                uniform sampler2D image;\n                varying vec2 st;\n                void main() {\n                    gl_FragColor = texture2D(image, st);\n                }");
      q.bindAttribLocation(g, 0, "vertex");
      q.bindAttribLocation(g, 1, "uv");
      q.linkProgram(g);
      t = q.getProgramInfoLog(g);
      if (0 < (t || "").trim().length) {
        throw t;
      }
      e = q.getUniformLocation(g, "mat");
      f = q.getUniformLocation(g, "translate");
      q.useProgram(g);
      q.bindBuffer(q.ARRAY_BUFFER, q.createBuffer());
      q.enableVertexAttribArray(0);
      q.enableVertexAttribArray(1);
      q.bindBuffer(q.ELEMENT_ARRAY_BUFFER, q.createBuffer());
      q.uniform1i(q.getUniformLocation(g, "image"), 0);
      q.pixelStorei(q.UNPACK_PREMULTIPLY_ALPHA_WEBGL, !0);
      a = q;
    }
    return !0;
  }
  let a = null, c = 0, d = 0, e = null, f = null, m = 0, h = 0, l = !1;
  b();
  this.Xa = function() {
    b();
    return d;
  };
  this.Ja = function(g) {
    a.deleteTexture && a.deleteTexture(g);
  };
  this.Ia = function(g) {
    if (!b()) {
      return null;
    }
    const t = a.createTexture();
    if (!t) {
      return null;
    }
    a.bindTexture(a.TEXTURE_2D, t);
    a.texImage2D(a.TEXTURE_2D, 0, a.RGBA, a.RGBA, a.UNSIGNED_BYTE, g);
    a.texParameteri(a.TEXTURE_2D, a.TEXTURE_WRAP_S, a.CLAMP_TO_EDGE);
    a.texParameteri(a.TEXTURE_2D, a.TEXTURE_WRAP_T, a.CLAMP_TO_EDGE);
    a.texParameteri(a.TEXTURE_2D, a.TEXTURE_MAG_FILTER, a.LINEAR);
    2 == c ? (a.texParameteri(a.TEXTURE_2D, a.TEXTURE_MIN_FILTER, a.LINEAR_MIPMAP_LINEAR), a.generateMipmap(a.TEXTURE_2D)) : a.texParameteri(a.TEXTURE_2D, a.TEXTURE_MIN_FILTER, a.LINEAR);
    return t;
  };
  const n = new la(8), r = new la(8), w = new la(10), z = new la(10);
  this.Ma = function(g, t, q, G, F) {
    if (b()) {
      var v = n.push(g), H = r.push(t);
      if (a.canvas) {
        if (a.canvas.width != v || a.canvas.height != H) {
          a.canvas.width = v, a.canvas.height = H;
        }
        a.viewport(0, H - t, g, t);
        a.disable(a.SCISSOR_TEST);
        a.clearColor(0, 0, 0, 0);
        a.clear(a.COLOR_BUFFER_BIT);
        a.enable(a.SCISSOR_TEST);
        q.sort((E, V) => V.ya - E.ya);
        v = w.push(G);
        m != v && (a.bufferData(a.ARRAY_BUFFER, 8 * v, a.DYNAMIC_DRAW), m = v);
        v = 0;
        for (var L of q) {
          a.bufferSubData(a.ARRAY_BUFFER, v, L.ia), v += 4 * L.ia.length;
        }
        console.assert(v == 4 * G);
        for (var Q of q) {
          a.bufferSubData(a.ARRAY_BUFFER, v, Q.Ba), v += 4 * Q.Ba.length;
        }
        console.assert(v == 8 * G);
        v = z.push(F);
        h != v && (a.bufferData(a.ELEMENT_ARRAY_BUFFER, 2 * v, a.DYNAMIC_DRAW), h = v);
        L = 0;
        for (var ha of q) {
          a.bufferSubData(a.ELEMENT_ARRAY_BUFFER, L, ha.indices), L += 2 * ha.indices.length;
        }
        console.assert(L == 2 * F);
        ha = 0;
        Q = !0;
        v = L = 0;
        for (const E of q) {
          E.image.da != ha && (a.bindTexture(a.TEXTURE_2D, E.image.ca || null), ha = E.image.da);
          E.$a ? (a.scissor(E.na, H - E.oa - E.ta, E.lb, E.ta), Q = !0) : Q && (a.scissor(0, H - t, g, t), Q = !1);
          q = 2 / g;
          const V = -2 / t;
          a.uniform4f(e, E.N[0] * q * E.X, E.N[1] * V * E.Y, E.N[2] * q * E.X, E.N[3] * V * E.Y);
          a.uniform2f(f, E.N[4] * q * E.X + q * (E.na - E.Ya * E.X) - 1, E.N[5] * V * E.Y + V * (E.oa - E.Za * E.Y) + 1);
          a.vertexAttribPointer(0, 2, a.FLOAT, !1, 0, v);
          a.vertexAttribPointer(1, 2, a.FLOAT, !1, 0, v + 4 * G);
          a.drawElements(a.TRIANGLES, E.indices.length, a.UNSIGNED_SHORT, L);
          v += 4 * E.ia.length;
          L += 2 * E.indices.length;
        }
        console.assert(v == 4 * G);
        console.assert(L == 2 * F);
      }
    }
  };
  this.canvas = function() {
    return b() && a.canvas;
  };
}(), ra = k.onRuntimeInitialized;
k.onRuntimeInitialized = function() {
  function b(p) {
    switch(p) {
      case n.srcOver:
        return "source-over";
      case n.screen:
        return "screen";
      case n.overlay:
        return "overlay";
      case n.darken:
        return "darken";
      case n.lighten:
        return "lighten";
      case n.colorDodge:
        return "color-dodge";
      case n.colorBurn:
        return "color-burn";
      case n.hardLight:
        return "hard-light";
      case n.softLight:
        return "soft-light";
      case n.difference:
        return "difference";
      case n.exclusion:
        return "exclusion";
      case n.multiply:
        return "multiply";
      case n.hue:
        return "hue";
      case n.saturation:
        return "saturation";
      case n.color:
        return "color";
      case n.luminosity:
        return "luminosity";
    }
  }
  function a(p) {
    return "rgba(" + ((16711680 & p) >>> 16) + "," + ((65280 & p) >>> 8) + "," + ((255 & p) >>> 0) + "," + ((4278190080 & p) >>> 24) / 255 + ")";
  }
  function c() {
    0 < H.length && (qa.Ma(v.drawWidth(), v.drawHeight(), H, L, Q), H = [], Q = L = 0, v.reset(512, 512));
    for (const p of F) {
      for (const u of p.v) {
        u();
      }
      p.v = [];
    }
    F.clear();
  }
  ra && ra();
  var d = k.RenderPaintStyle;
  const e = k.RenderPath, f = k.RenderPaint, m = k.Renderer, h = k.StrokeCap, l = k.StrokeJoin, n = k.BlendMode, r = d.fill, w = d.stroke, z = k.FillRule.evenOdd;
  let g = 1;
  var t = k.RenderImage.extend("CanvasRenderImage", {__construct:function({R:p, W:u} = {}) {
    this.__parent.__construct.call(this);
    this.da = g;
    g = g + 1 & 2147483647 || 1;
    this.R = p;
    this.W = u;
  }, __destruct:function() {
    this.ca && (qa.Ja(this.ca), URL.revokeObjectURL(this.la));
    this.__parent.__destruct.call(this);
  }, decode:function(p) {
    var u = this;
    u.W && u.W(u);
    var D = new Image();
    u.la = URL.createObjectURL(new Blob([p], {type:"image/png",}));
    D.onload = function() {
      u.Da = D;
      u.ca = qa.Ia(D);
      u.size(D.width, D.height);
      u.R && u.R(u);
    };
    D.src = u.la;
  },}), q = e.extend("CanvasRenderPath", {__construct:function() {
    this.__parent.__construct.call(this);
    this.H = new Path2D();
  }, rewind:function() {
    this.H = new Path2D();
  }, addPath:function(p, u, D, B, x, C, A) {
    var I = this.H, na = I.addPath;
    p = p.H;
    const P = new DOMMatrix();
    P.a = u;
    P.b = D;
    P.c = B;
    P.d = x;
    P.e = C;
    P.f = A;
    na.call(I, p, P);
  }, fillRule:function(p) {
    this.ka = p;
  }, moveTo:function(p, u) {
    this.H.moveTo(p, u);
  }, lineTo:function(p, u) {
    this.H.lineTo(p, u);
  }, cubicTo:function(p, u, D, B, x, C) {
    this.H.bezierCurveTo(p, u, D, B, x, C);
  }, close:function() {
    this.H.closePath();
  },}), G = f.extend("CanvasRenderPaint", {color:function(p) {
    this.ma = a(p);
  }, thickness:function(p) {
    this.Ga = p;
  }, join:function(p) {
    switch(p) {
      case l.miter:
        this.ba = "miter";
        break;
      case l.round:
        this.ba = "round";
        break;
      case l.bevel:
        this.ba = "bevel";
    }
  }, cap:function(p) {
    switch(p) {
      case h.butt:
        this.aa = "butt";
        break;
      case h.round:
        this.aa = "round";
        break;
      case h.square:
        this.aa = "square";
    }
  }, style:function(p) {
    this.Fa = p;
  }, blendMode:function(p) {
    this.Ca = b(p);
  }, clearGradient:function() {
    this.P = null;
  }, linearGradient:function(p, u, D, B) {
    this.P = {za:p, Aa:u, qa:D, ra:B, ga:[],};
  }, radialGradient:function(p, u, D, B) {
    this.P = {za:p, Aa:u, qa:D, ra:B, ga:[], Wa:!0,};
  }, addStop:function(p, u) {
    this.P.ga.push({color:p, stop:u,});
  }, completeGradient:function() {
  }, draw:function(p, u, D, B) {
    let x = this.Fa;
    var C = this.ma, A = this.P;
    const I = p.globalCompositeOperation, na = p.globalAlpha;
    p.globalCompositeOperation = this.Ca;
    p.globalAlpha = B;
    if (null != A) {
      C = A.za;
      const T = A.Aa, ca = A.qa;
      var P = A.ra;
      B = A.ga;
      A.Wa ? (A = ca - C, P -= T, C = p.createRadialGradient(C, T, 0, C, T, Math.sqrt(A * A + P * P))) : C = p.createLinearGradient(C, T, ca, P);
      for (let U = 0, W = B.length; U < W; U++) {
        A = B[U], C.addColorStop(A.stop, a(A.color));
      }
      this.ma = C;
      this.P = null;
    }
    switch(x) {
      case w:
        p.strokeStyle = C;
        p.lineWidth = this.Ga;
        p.lineCap = this.aa;
        p.lineJoin = this.ba;
        p.stroke(u);
        break;
      case r:
        p.fillStyle = C, p.fill(u, D);
    }
    p.globalCompositeOperation = I;
    p.globalAlpha = na;
  },});
  const F = new Set();
  let v = null, H = [], L = 0, Q = 0;
  var ha = k.CanvasRenderer = m.extend("Renderer", {__construct:function(p) {
    this.__parent.__construct.call(this);
    this.G = [1, 0, 0, 1, 0, 0];
    this.u = [1.0];
    this.m = p.getContext("2d");
    this.ja = p;
    this.v = [];
  }, save:function() {
    this.G.push(...this.G.slice(this.G.length - 6));
    this.u.push(this.u[this.u.length - 1]);
    this.v.push(this.m.save.bind(this.m));
  }, restore:function() {
    const p = this.G.length - 6;
    if (6 > p) {
      throw "restore() called without matching save().";
    }
    this.G.splice(p);
    this.u.pop();
    this.v.push(this.m.restore.bind(this.m));
  }, transform:function(p, u, D, B, x, C) {
    const A = this.G, I = A.length - 6;
    A.splice(I, 6, A[I] * p + A[I + 2] * u, A[I + 1] * p + A[I + 3] * u, A[I] * D + A[I + 2] * B, A[I + 1] * D + A[I + 3] * B, A[I] * x + A[I + 2] * C + A[I + 4], A[I + 1] * x + A[I + 3] * C + A[I + 5]);
    this.v.push(this.m.transform.bind(this.m, p, u, D, B, x, C));
  }, rotate:function(p) {
    const u = Math.sin(p);
    p = Math.cos(p);
    this.transform(p, u, -u, p, 0, 0);
  }, modulateOpacity:function(p) {
    this.u[this.u.length - 1] *= p;
  }, _drawPath:function(p, u) {
    this.v.push(u.draw.bind(u, this.m, p.H, p.ka === z ? "evenodd" : "nonzero", Math.max(0, this.u[this.u.length - 1])));
  }, _drawRiveImage:function(p, u, D, B) {
    var x = p.Da;
    if (x) {
      var C = this.m, A = b(D), I = Math.max(0, B * this.u[this.u.length - 1]);
      this.v.push(function() {
        C.globalCompositeOperation = A;
        C.globalAlpha = I;
        C.drawImage(x, 0, 0);
        C.globalAlpha = 1;
      });
    }
  }, _getMatrix:function(p) {
    const u = this.G, D = u.length - 6;
    for (let B = 0; 6 > B; ++B) {
      p[B] = u[D + B];
    }
  }, _drawImageMesh:function(p, u, D, B, x, C, A, I, na, P, T, ca, U, W) {
    let ub, vb, wb;
    try {
      ub = k.HEAPF32.slice(x >> 2, (x >> 2) + C), vb = k.HEAPF32.slice(A >> 2, (A >> 2) + I), wb = k.HEAPU16.slice(na >> 1, (na >> 1) + P);
    } catch (Ya) {
      console.error("[Rive] _drawImageMesh: failed to read mesh data from WASM heap. Mesh skipped for this frame.");
      return;
    }
    u = this.m.canvas.width;
    x = this.m.canvas.height;
    A = U - T;
    I = W - ca;
    T = Math.max(T, 0);
    ca = Math.max(ca, 0);
    U = Math.min(U, u);
    W = Math.min(W, x);
    const va = U - T, wa = W - ca;
    console.assert(va <= Math.min(A, u));
    console.assert(wa <= Math.min(I, x));
    if (!(0 >= va || 0 >= wa)) {
      U = va < A || wa < I;
      u = W = 1;
      var ia = Math.ceil(va * W), ja = Math.ceil(wa * u);
      x = qa.Xa();
      ia > x && (W *= x / ia, ia = x);
      ja > x && (u *= x / ja, ja = x);
      v || (v = new k.DynamicRectanizer(x), v.reset(512, 512));
      x = v.addRect(ia, ja);
      0 > x && (c(), F.add(this), x = v.addRect(ia, ja), console.assert(0 <= x));
      var xb = x & 65535, yb = x >> 16;
      H.push({N:this.G.slice(this.G.length - 6), image:p, na:xb, oa:yb, Ya:T, Za:ca, lb:ia, ta:ja, X:W, Y:u, ia:ub, Ba:vb, indices:wb, $a:U, ya:p.da << 1 | (U ? 1 : 0),});
      L += C;
      Q += P;
      var oa = this.m, oc = b(D), pc = Math.max(0, B * this.u[this.u.length - 1]);
      this.v.push(function() {
        oa.save();
        oa.resetTransform();
        oa.globalCompositeOperation = oc;
        oa.globalAlpha = pc;
        const Ya = qa.canvas();
        Ya && oa.drawImage(Ya, xb, yb, ia, ja, T, ca, va, wa);
        oa.restore();
      });
    }
  }, _clipPath:function(p) {
    this.v.push(this.m.clip.bind(this.m, p.H, p.ka === z ? "evenodd" : "nonzero"));
  }, clear:function() {
    F.add(this);
    this.v.push(this.m.clearRect.bind(this.m, 0, 0, this.ja.width, this.ja.height));
  }, flush:function() {
  }, translate:function(p, u) {
    this.transform(1, 0, 0, 1, p, u);
  },});
  k.makeRenderer = function(p) {
    const u = new ha(p), D = u.m;
    return new Proxy(u, {get(B, x) {
      if ("function" === typeof B[x]) {
        return function(...C) {
          return B[x].apply(B, C);
        };
      }
      if ("function" === typeof D[x]) {
        if (-1 < pa.indexOf(x)) {
          throw Error("RiveException: Method call to '" + x + "()' is not allowed, as the renderer cannot immediately pass through the return                 values of any canvas 2d context methods.");
        }
        return function(...C) {
          u.v.push(D[x].bind(D, ...C));
        };
      }
      return B[x];
    }, set(B, x, C) {
      if (x in D) {
        return u.v.push(() => {
          D[x] = C;
        }), !0;
      }
    },});
  };
  k.decodeImage = function(p, u) {
    (new t({R:u})).decode(p);
  };
  k.renderFactory = {makeRenderPaint:function() {
    return new G();
  }, makeRenderPath:function() {
    return new q();
  }, makeRenderImage:function() {
    let p = V;
    return new t({W:() => {
      p.total++;
    }, R:() => {
      p.loaded++;
      if (p.loaded === p.total) {
        const u = p.ready;
        u && (u(), p.ready = null);
      }
    },});
  },};
  let E = k.load, V = null;
  k.load = function(p, u, D = !0) {
    const B = new k.FallbackFileAssetLoader();
    void 0 !== u && B.addLoader(u);
    D && (u = new k.CDNFileAssetLoader(), B.addLoader(u));
    return new Promise(function(x) {
      let C = null;
      V = {total:0, loaded:0, ready:function() {
        x(C);
      },};
      C = E(p, B);
      0 == V.total && x(C);
    });
  };
  let qc = k.RendererWrapper.prototype.align;
  k.RendererWrapper.prototype.align = function(p, u, D, B, x = 1.0) {
    qc.call(this, p, u, D, B, x);
  };
  d = new ka();
  k.requestAnimationFrame = d.requestAnimationFrame.bind(d);
  k.cancelAnimationFrame = d.cancelAnimationFrame.bind(d);
  k.enableFPSCounter = d.Na.bind(d);
  k.disableFPSCounter = d.Ka;
  d.va = c;
  k.resolveAnimationFrame = c;
  k.cleanup = function() {
    v && v.delete();
  };
};
var sa = Object.assign({}, k), ta = "./this.program", y = "", ua, xa;
if (ea || fa) {
  fa ? y = self.location.href : "undefined" != typeof document && document.currentScript && (y = document.currentScript.src), _scriptName && (y = _scriptName), y.startsWith("blob:") ? y = "" : y = y.substr(0, y.replace(/[?#].*/, "").lastIndexOf("/") + 1), fa && (xa = b => {
    var a = new XMLHttpRequest();
    a.open("GET", b, !1);
    a.responseType = "arraybuffer";
    a.send(null);
    return new Uint8Array(a.response);
  }), ua = (b, a, c) => {
    if (ya(b)) {
      var d = new XMLHttpRequest();
      d.open("GET", b, !0);
      d.responseType = "arraybuffer";
      d.onload = () => {
        200 == d.status || 0 == d.status && d.response ? a(d.response) : c();
      };
      d.onerror = c;
      d.send(null);
    } else {
      fetch(b, {credentials:"same-origin"}).then(e => e.ok ? e.arrayBuffer() : Promise.reject(Error(e.status + " : " + e.url))).then(a, c);
    }
  };
}
var za = k.print || console.log.bind(console), Aa = k.printErr || console.error.bind(console);
Object.assign(k, sa);
sa = null;
k.thisProgram && (ta = k.thisProgram);
var Ba;
k.wasmBinary && (Ba = k.wasmBinary);
var Ca, Da = !1, Ea, J, Fa, Ga, K, M, Ha, Ia;
function Ja() {
  var b = Ca.buffer;
  k.HEAP8 = Ea = new Int8Array(b);
  k.HEAP16 = Fa = new Int16Array(b);
  k.HEAPU8 = J = new Uint8Array(b);
  k.HEAPU16 = Ga = new Uint16Array(b);
  k.HEAP32 = K = new Int32Array(b);
  k.HEAPU32 = M = new Uint32Array(b);
  k.HEAPF32 = Ha = new Float32Array(b);
  k.HEAPF64 = Ia = new Float64Array(b);
}
var Ka = [], La = [], Ma = [];
function Na() {
  var b = k.preRun.shift();
  Ka.unshift(b);
}
var Oa = 0, Pa = null, Qa = null;
function Ra(b) {
  k.onAbort?.(b);
  b = "Aborted(" + b + ")";
  Aa(b);
  Da = !0;
  b = new WebAssembly.RuntimeError(b + ". Build with -sASSERTIONS for more info.");
  ba(b);
  throw b;
}
var Sa = b => b.startsWith("data:application/octet-stream;base64,"), ya = b => b.startsWith("file://"), Ta;
function Ua(b) {
  if (b == Ta && Ba) {
    return new Uint8Array(Ba);
  }
  if (xa) {
    return xa(b);
  }
  throw "both async and sync fetching of the wasm failed";
}
function Va(b) {
  return Ba ? Promise.resolve().then(() => Ua(b)) : new Promise((a, c) => {
    ua(b, d => a(new Uint8Array(d)), () => {
      try {
        a(Ua(b));
      } catch (d) {
        c(d);
      }
    });
  });
}
function Wa(b, a, c) {
  return Va(b).then(d => WebAssembly.instantiate(d, a)).then(c, d => {
    Aa(`failed to asynchronously prepare wasm: ${d}`);
    Ra(d);
  });
}
function Xa(b, a) {
  var c = Ta;
  return Ba || "function" != typeof WebAssembly.instantiateStreaming || Sa(c) || ya(c) || "function" != typeof fetch ? Wa(c, b, a) : fetch(c, {credentials:"same-origin"}).then(d => WebAssembly.instantiateStreaming(d, b).then(a, function(e) {
    Aa(`wasm streaming compile failed: ${e}`);
    Aa("falling back to ArrayBuffer instantiation");
    return Wa(c, b, a);
  }));
}
var Za = b => {
  for (; 0 < b.length;) {
    b.shift()(k);
  }
}, $a = (b, a) => Object.defineProperty(a, "name", {value:b}), ab = [], N = [], O, R = b => {
  if (!b) {
    throw new O("Cannot use deleted val. handle = " + b);
  }
  return N[b];
}, bb = b => {
  switch(b) {
    case void 0:
      return 2;
    case null:
      return 4;
    case !0:
      return 6;
    case !1:
      return 8;
    default:
      const a = ab.pop() || N.length;
      N[a] = b;
      N[a + 1] = 1;
      return a;
  }
}, cb = b => {
  var a = Error, c = $a(b, function(d) {
    this.name = b;
    this.message = d;
    d = Error(d).stack;
    void 0 !== d && (this.stack = this.toString() + "\n" + d.replace(/^Error(:[^\n]*)?\n/, ""));
  });
  c.prototype = Object.create(a.prototype);
  c.prototype.constructor = c;
  c.prototype.toString = function() {
    return void 0 === this.message ? this.name : `${this.name}: ${this.message}`;
  };
  return c;
}, db, eb, S = b => {
  for (var a = ""; J[b];) {
    a += eb[J[b++]];
  }
  return a;
}, fb = [], gb = () => {
  for (; fb.length;) {
    var b = fb.pop();
    b.g.M = !1;
    b["delete"]();
  }
}, hb, ib = {}, jb = (b, a) => {
  if (void 0 === a) {
    throw new O("ptr should not be undefined");
  }
  for (; b.o;) {
    a = b.S(a), b = b.o;
  }
  return a;
}, kb = {}, nb = b => {
  b = lb(b);
  var a = S(b);
  mb(b);
  return a;
}, ob = (b, a) => {
  var c = kb[b];
  if (void 0 === c) {
    throw b = `${a} has unknown type ${nb(b)}`, new O(b);
  }
  return c;
}, pb = () => {
}, qb = !1, rb = (b, a, c) => {
  if (a === c) {
    return b;
  }
  if (void 0 === c.o) {
    return null;
  }
  b = rb(b, a, c.o);
  return null === b ? null : c.La(b);
}, sb = {}, tb = (b, a) => {
  a = jb(b, a);
  return ib[a];
}, zb, Bb = (b, a) => {
  if (!a.j || !a.i) {
    throw new zb("makeClassHandle requires ptr and ptrType");
  }
  if (!!a.A !== !!a.s) {
    throw new zb("Both smartPtrType and smartPtr must be specified");
  }
  a.count = {value:1};
  return Ab(Object.create(b, {g:{value:a, writable:!0,},}));
}, Ab = b => {
  if ("undefined" === typeof FinalizationRegistry) {
    return Ab = a => a, b;
  }
  qb = new FinalizationRegistry(a => {
    a = a.g;
    --a.count.value;
    0 === a.count.value && (a.s ? a.A.D(a.s) : a.j.h.D(a.i));
  });
  Ab = a => {
    var c = a.g;
    c.s && qb.register(a, {g:c}, a);
    return a;
  };
  pb = a => {
    qb.unregister(a);
  };
  return Ab(b);
}, Cb = {}, Db = b => {
  for (; b.length;) {
    var a = b.pop();
    b.pop()(a);
  }
};
function Eb(b) {
  return this.fromWireType(M[b >> 2]);
}
var Fb = {}, Gb = {}, X = (b, a, c) => {
  function d(h) {
    h = c(h);
    if (h.length !== b.length) {
      throw new zb("Mismatched type converter count");
    }
    for (var l = 0; l < b.length; ++l) {
      Hb(b[l], h[l]);
    }
  }
  b.forEach(function(h) {
    Gb[h] = a;
  });
  var e = Array(a.length), f = [], m = 0;
  a.forEach((h, l) => {
    kb.hasOwnProperty(h) ? e[l] = kb[h] : (f.push(h), Fb.hasOwnProperty(h) || (Fb[h] = []), Fb[h].push(() => {
      e[l] = kb[h];
      ++m;
      m === f.length && d(e);
    }));
  });
  0 === f.length && d(e);
};
function Ib(b, a, c = {}) {
  var d = a.name;
  if (!b) {
    throw new O(`type "${d}" must have a positive integer typeid pointer`);
  }
  if (kb.hasOwnProperty(b)) {
    if (c.Va) {
      return;
    }
    throw new O(`Cannot register type '${d}' twice`);
  }
  kb[b] = a;
  delete Gb[b];
  Fb.hasOwnProperty(b) && (a = Fb[b], delete Fb[b], a.forEach(e => e()));
}
function Hb(b, a, c = {}) {
  if (!("argPackAdvance" in a)) {
    throw new TypeError("registerType registeredInstance requires argPackAdvance");
  }
  return Ib(b, a, c);
}
var Jb = b => {
  throw new O(b.g.j.h.name + " instance already deleted");
};
function Kb() {
}
var Lb = (b, a, c) => {
  if (void 0 === b[a].l) {
    var d = b[a];
    b[a] = function(...e) {
      if (!b[a].l.hasOwnProperty(e.length)) {
        throw new O(`Function '${c}' called with an invalid number of arguments (${e.length}) - expects one of (${b[a].l})!`);
      }
      return b[a].l[e.length].apply(this, e);
    };
    b[a].l = [];
    b[a].l[d.L] = d;
  }
}, Mb = (b, a, c) => {
  if (k.hasOwnProperty(b)) {
    if (void 0 === c || void 0 !== k[b].l && void 0 !== k[b].l[c]) {
      throw new O(`Cannot register public name '${b}' twice`);
    }
    Lb(k, b, b);
    if (k.hasOwnProperty(c)) {
      throw new O(`Cannot register multiple overloads of a function with the same number of arguments (${c})!`);
    }
    k[b].l[c] = a;
  } else {
    k[b] = a, void 0 !== c && (k[b].nb = c);
  }
}, Nb = b => {
  if (void 0 === b) {
    return "_unknown";
  }
  b = b.replace(/[^a-zA-Z0-9_]/g, "$");
  var a = b.charCodeAt(0);
  return 48 <= a && 57 >= a ? `_${b}` : b;
};
function Ob(b, a, c, d, e, f, m, h) {
  this.name = b;
  this.constructor = a;
  this.C = c;
  this.D = d;
  this.o = e;
  this.Qa = f;
  this.S = m;
  this.La = h;
  this.wa = [];
}
var Pb = (b, a, c) => {
  for (; a !== c;) {
    if (!a.S) {
      throw new O(`Expected null or instance of ${c.name}, got an instance of ${a.name}`);
    }
    b = a.S(b);
    a = a.o;
  }
  return b;
};
function Qb(b, a) {
  if (null === a) {
    if (this.ea) {
      throw new O(`null is not a valid ${this.name}`);
    }
    return 0;
  }
  if (!a.g) {
    throw new O(`Cannot pass "${Rb(a)}" as a ${this.name}`);
  }
  if (!a.g.i) {
    throw new O(`Cannot pass deleted object as a pointer of type ${this.name}`);
  }
  return Pb(a.g.i, a.g.j.h, this.h);
}
function Sb(b, a) {
  if (null === a) {
    if (this.ea) {
      throw new O(`null is not a valid ${this.name}`);
    }
    if (this.V) {
      var c = this.fa();
      null !== b && b.push(this.D, c);
      return c;
    }
    return 0;
  }
  if (!a || !a.g) {
    throw new O(`Cannot pass "${Rb(a)}" as a ${this.name}`);
  }
  if (!a.g.i) {
    throw new O(`Cannot pass deleted object as a pointer of type ${this.name}`);
  }
  if (!this.U && a.g.j.U) {
    throw new O(`Cannot convert argument of type ${a.g.A ? a.g.A.name : a.g.j.name} to parameter type ${this.name}`);
  }
  c = Pb(a.g.i, a.g.j.h, this.h);
  if (this.V) {
    if (void 0 === a.g.s) {
      throw new O("Passing raw pointer to smart pointer is illegal");
    }
    switch(this.gb) {
      case 0:
        if (a.g.A === this) {
          c = a.g.s;
        } else {
          throw new O(`Cannot convert argument of type ${a.g.A ? a.g.A.name : a.g.j.name} to parameter type ${this.name}`);
        }
        break;
      case 1:
        c = a.g.s;
        break;
      case 2:
        if (a.g.A === this) {
          c = a.g.s;
        } else {
          var d = a.clone();
          c = this.bb(c, bb(() => d["delete"]()));
          null !== b && b.push(this.D, c);
        }
        break;
      default:
        throw new O("Unsupporting sharing policy");
    }
  }
  return c;
}
function Tb(b, a) {
  if (null === a) {
    if (this.ea) {
      throw new O(`null is not a valid ${this.name}`);
    }
    return 0;
  }
  if (!a.g) {
    throw new O(`Cannot pass "${Rb(a)}" as a ${this.name}`);
  }
  if (!a.g.i) {
    throw new O(`Cannot pass deleted object as a pointer of type ${this.name}`);
  }
  if (a.g.j.U) {
    throw new O(`Cannot convert argument of type ${a.g.j.name} to parameter type ${this.name}`);
  }
  return Pb(a.g.i, a.g.j.h, this.h);
}
function Ub(b, a, c, d, e, f, m, h, l, n, r) {
  this.name = b;
  this.h = a;
  this.ea = c;
  this.U = d;
  this.V = e;
  this.ab = f;
  this.gb = m;
  this.xa = h;
  this.fa = l;
  this.bb = n;
  this.D = r;
  e || void 0 !== a.o ? this.toWireType = Sb : (this.toWireType = d ? Qb : Tb, this.B = null);
}
var Vb = (b, a, c) => {
  if (!k.hasOwnProperty(b)) {
    throw new zb("Replacing nonexistent public symbol");
  }
  void 0 !== k[b].l && void 0 !== c ? k[b].l[c] = a : (k[b] = a, k[b].L = c);
}, Wb = [], Xb, Yb = b => {
  var a = Wb[b];
  a || (b >= Wb.length && (Wb.length = b + 1), Wb[b] = a = Xb.get(b));
  return a;
}, Zb = (b, a, c = []) => {
  b.includes("j") ? (b = b.replace(/p/g, "i"), a = (0,k["dynCall_" + b])(a, ...c)) : a = Yb(a)(...c);
  return a;
}, $b = (b, a) => (...c) => Zb(b, a, c), Y = (b, a) => {
  b = S(b);
  var c = b.includes("j") ? $b(b, a) : Yb(a);
  if ("function" != typeof c) {
    throw new O(`unknown function pointer with signature ${b}: ${a}`);
  }
  return c;
}, ac, bc = (b, a) => {
  function c(f) {
    e[f] || kb[f] || (Gb[f] ? Gb[f].forEach(c) : (d.push(f), e[f] = !0));
  }
  var d = [], e = {};
  a.forEach(c);
  throw new ac(`${b}: ` + d.map(nb).join([", "]));
};
function cc(b) {
  for (var a = 1; a < b.length; ++a) {
    if (null !== b[a] && void 0 === b[a].B) {
      return !0;
    }
  }
  return !1;
}
function dc(b, a, c, d, e) {
  var f = a.length;
  if (2 > f) {
    throw new O("argTypes array size mismatch! Must at least get return value and 'this' types!");
  }
  var m = null !== a[1] && null !== c, h = cc(a), l = "void" !== a[0].name, n = f - 2, r = Array(n), w = [], z = [];
  return $a(b, function(...g) {
    if (g.length !== n) {
      throw new O(`function ${b} called with ${g.length} arguments, expected ${n}`);
    }
    z.length = 0;
    w.length = m ? 2 : 1;
    w[0] = e;
    if (m) {
      var t = a[1].toWireType(z, this);
      w[1] = t;
    }
    for (var q = 0; q < n; ++q) {
      r[q] = a[q + 2].toWireType(z, g[q]), w.push(r[q]);
    }
    g = d(...w);
    if (h) {
      Db(z);
    } else {
      for (q = m ? 1 : 2; q < a.length; q++) {
        var G = 1 === q ? t : r[q - 2];
        null !== a[q].B && a[q].B(G);
      }
    }
    t = l ? a[0].fromWireType(g) : void 0;
    return t;
  });
}
var ec = (b, a) => {
  for (var c = [], d = 0; d < b; d++) {
    c.push(M[a + 4 * d >> 2]);
  }
  return c;
}, fc = b => {
  b = b.trim();
  const a = b.indexOf("(");
  return -1 !== a ? b.substr(0, a) : b;
}, gc = (b, a, c) => {
  if (!(b instanceof Object)) {
    throw new O(`${c} with invalid "this": ${b}`);
  }
  if (!(b instanceof a.h.constructor)) {
    throw new O(`${c} incompatible with "this" of type ${b.constructor.name}`);
  }
  if (!b.g.i) {
    throw new O(`cannot call emscripten binding method ${c} on deleted object`);
  }
  return Pb(b.g.i, b.g.j.h, a.h);
}, hc = b => {
  9 < b && 0 === --N[b + 1] && (N[b] = void 0, ab.push(b));
}, ic = {name:"emscripten::val", fromWireType:b => {
  var a = R(b);
  hc(b);
  return a;
}, toWireType:(b, a) => bb(a), argPackAdvance:8, readValueFromPointer:Eb, B:null,}, jc = (b, a, c) => {
  switch(a) {
    case 1:
      return c ? function(d) {
        return this.fromWireType(Ea[d]);
      } : function(d) {
        return this.fromWireType(J[d]);
      };
    case 2:
      return c ? function(d) {
        return this.fromWireType(Fa[d >> 1]);
      } : function(d) {
        return this.fromWireType(Ga[d >> 1]);
      };
    case 4:
      return c ? function(d) {
        return this.fromWireType(K[d >> 2]);
      } : function(d) {
        return this.fromWireType(M[d >> 2]);
      };
    default:
      throw new TypeError(`invalid integer width (${a}): ${b}`);
  }
}, Rb = b => {
  if (null === b) {
    return "null";
  }
  var a = typeof b;
  return "object" === a || "array" === a || "function" === a ? b.toString() : "" + b;
}, kc = (b, a) => {
  switch(a) {
    case 4:
      return function(c) {
        return this.fromWireType(Ha[c >> 2]);
      };
    case 8:
      return function(c) {
        return this.fromWireType(Ia[c >> 3]);
      };
    default:
      throw new TypeError(`invalid float width (${a}): ${b}`);
  }
}, lc = (b, a, c) => {
  switch(a) {
    case 1:
      return c ? d => Ea[d] : d => J[d];
    case 2:
      return c ? d => Fa[d >> 1] : d => Ga[d >> 1];
    case 4:
      return c ? d => K[d >> 2] : d => M[d >> 2];
    default:
      throw new TypeError(`invalid integer width (${a}): ${b}`);
  }
}, mc = (b, a, c, d) => {
  if (0 < d) {
    d = c + d - 1;
    for (var e = 0; e < b.length; ++e) {
      var f = b.charCodeAt(e);
      if (55296 <= f && 57343 >= f) {
        var m = b.charCodeAt(++e);
        f = 65536 + ((f & 1023) << 10) | m & 1023;
      }
      if (127 >= f) {
        if (c >= d) {
          break;
        }
        a[c++] = f;
      } else {
        if (2047 >= f) {
          if (c + 1 >= d) {
            break;
          }
          a[c++] = 192 | f >> 6;
        } else {
          if (65535 >= f) {
            if (c + 2 >= d) {
              break;
            }
            a[c++] = 224 | f >> 12;
          } else {
            if (c + 3 >= d) {
              break;
            }
            a[c++] = 240 | f >> 18;
            a[c++] = 128 | f >> 12 & 63;
          }
          a[c++] = 128 | f >> 6 & 63;
        }
        a[c++] = 128 | f & 63;
      }
    }
    a[c] = 0;
  }
}, nc = b => {
  for (var a = 0, c = 0; c < b.length; ++c) {
    var d = b.charCodeAt(c);
    127 >= d ? a++ : 2047 >= d ? a += 2 : 55296 <= d && 57343 >= d ? (a += 4, ++c) : a += 3;
  }
  return a;
}, rc = "undefined" != typeof TextDecoder ? new TextDecoder("utf8") : void 0, sc = (b, a, c) => {
  var d = a + c;
  for (c = a; b[c] && !(c >= d);) {
    ++c;
  }
  if (16 < c - a && b.buffer && rc) {
    return rc.decode(b.subarray(a, c));
  }
  for (d = ""; a < c;) {
    var e = b[a++];
    if (e & 128) {
      var f = b[a++] & 63;
      if (192 == (e & 224)) {
        d += String.fromCharCode((e & 31) << 6 | f);
      } else {
        var m = b[a++] & 63;
        e = 224 == (e & 240) ? (e & 15) << 12 | f << 6 | m : (e & 7) << 18 | f << 12 | m << 6 | b[a++] & 63;
        65536 > e ? d += String.fromCharCode(e) : (e -= 65536, d += String.fromCharCode(55296 | e >> 10, 56320 | e & 1023));
      }
    } else {
      d += String.fromCharCode(e);
    }
  }
  return d;
}, tc = "undefined" != typeof TextDecoder ? new TextDecoder("utf-16le") : void 0, uc = (b, a) => {
  var c = b >> 1;
  for (var d = c + a / 2; !(c >= d) && Ga[c];) {
    ++c;
  }
  c <<= 1;
  if (32 < c - b && tc) {
    return tc.decode(J.subarray(b, c));
  }
  c = "";
  for (d = 0; !(d >= a / 2); ++d) {
    var e = Fa[b + 2 * d >> 1];
    if (0 == e) {
      break;
    }
    c += String.fromCharCode(e);
  }
  return c;
}, vc = (b, a, c) => {
  c ??= 2147483647;
  if (2 > c) {
    return 0;
  }
  c -= 2;
  var d = a;
  c = c < 2 * b.length ? c / 2 : b.length;
  for (var e = 0; e < c; ++e) {
    Fa[a >> 1] = b.charCodeAt(e), a += 2;
  }
  Fa[a >> 1] = 0;
  return a - d;
}, wc = b => 2 * b.length, xc = (b, a) => {
  for (var c = 0, d = ""; !(c >= a / 4);) {
    var e = K[b + 4 * c >> 2];
    if (0 == e) {
      break;
    }
    ++c;
    65536 <= e ? (e -= 65536, d += String.fromCharCode(55296 | e >> 10, 56320 | e & 1023)) : d += String.fromCharCode(e);
  }
  return d;
}, yc = (b, a, c) => {
  c ??= 2147483647;
  if (4 > c) {
    return 0;
  }
  var d = a;
  c = d + c - 4;
  for (var e = 0; e < b.length; ++e) {
    var f = b.charCodeAt(e);
    if (55296 <= f && 57343 >= f) {
      var m = b.charCodeAt(++e);
      f = 65536 + ((f & 1023) << 10) | m & 1023;
    }
    K[a >> 2] = f;
    a += 4;
    if (a + 4 > c) {
      break;
    }
  }
  K[a >> 2] = 0;
  return a - d;
}, zc = b => {
  for (var a = 0, c = 0; c < b.length; ++c) {
    var d = b.charCodeAt(c);
    55296 <= d && 57343 >= d && ++c;
    a += 4;
  }
  return a;
}, Ac = (b, a, c) => {
  var d = [];
  b = b.toWireType(d, c);
  d.length && (M[a >> 2] = bb(d));
  return b;
}, Bc = {}, Cc = b => {
  var a = Bc[b];
  return void 0 === a ? S(b) : a;
}, Dc = [], Ec = b => {
  var a = Dc.length;
  Dc.push(b);
  return a;
}, Fc = (b, a) => {
  for (var c = Array(b), d = 0; d < b; ++d) {
    c[d] = ob(M[a + 4 * d >> 2], "parameter " + d);
  }
  return c;
}, Gc = Reflect.construct, Hc = {}, Jc = () => {
  if (!Ic) {
    var b = {USER:"web_user", LOGNAME:"web_user", PATH:"/", PWD:"/", HOME:"/home/web_user", LANG:("object" == typeof navigator && navigator.languages && navigator.languages[0] || "C").replace("-", "_") + ".UTF-8", _:ta || "./this.program"}, a;
    for (a in Hc) {
      void 0 === Hc[a] ? delete b[a] : b[a] = Hc[a];
    }
    var c = [];
    for (a in b) {
      c.push(`${a}=${b[a]}`);
    }
    Ic = c;
  }
  return Ic;
}, Ic, Kc = [null, [], []], Lc = b => 0 === b % 4 && (0 !== b % 100 || 0 === b % 400), Mc = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], Nc = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function Oc(b) {
  var a = Array(nc(b) + 1);
  mc(b, a, 0, a.length);
  return a;
}
var Pc = (b, a, c, d) => {
  function e(g, t, q) {
    for (g = "number" == typeof g ? g.toString() : g || ""; g.length < t;) {
      g = q[0] + g;
    }
    return g;
  }
  function f(g, t) {
    return e(g, t, "0");
  }
  function m(g, t) {
    function q(F) {
      return 0 > F ? -1 : 0 < F ? 1 : 0;
    }
    var G;
    0 === (G = q(g.getFullYear() - t.getFullYear())) && 0 === (G = q(g.getMonth() - t.getMonth())) && (G = q(g.getDate() - t.getDate()));
    return G;
  }
  function h(g) {
    switch(g.getDay()) {
      case 0:
        return new Date(g.getFullYear() - 1, 11, 29);
      case 1:
        return g;
      case 2:
        return new Date(g.getFullYear(), 0, 3);
      case 3:
        return new Date(g.getFullYear(), 0, 2);
      case 4:
        return new Date(g.getFullYear(), 0, 1);
      case 5:
        return new Date(g.getFullYear() - 1, 11, 31);
      case 6:
        return new Date(g.getFullYear() - 1, 11, 30);
    }
  }
  function l(g) {
    var t = g.J;
    for (g = new Date((new Date(g.K + 1900, 0, 1)).getTime()); 0 < t;) {
      var q = g.getMonth(), G = (Lc(g.getFullYear()) ? Mc : Nc)[q];
      if (t > G - g.getDate()) {
        t -= G - g.getDate() + 1, g.setDate(1), 11 > q ? g.setMonth(q + 1) : (g.setMonth(0), g.setFullYear(g.getFullYear() + 1));
      } else {
        g.setDate(g.getDate() + t);
        break;
      }
    }
    q = new Date(g.getFullYear() + 1, 0, 4);
    t = h(new Date(g.getFullYear(), 0, 4));
    q = h(q);
    return 0 >= m(t, g) ? 0 >= m(q, g) ? g.getFullYear() + 1 : g.getFullYear() : g.getFullYear() - 1;
  }
  var n = M[d + 40 >> 2];
  d = {jb:K[d >> 2], ib:K[d + 4 >> 2], Z:K[d + 8 >> 2], ha:K[d + 12 >> 2], $:K[d + 16 >> 2], K:K[d + 20 >> 2], F:K[d + 24 >> 2], J:K[d + 28 >> 2], ob:K[d + 32 >> 2], hb:K[d + 36 >> 2], kb:n ? n ? sc(J, n) : "" : ""};
  c = c ? sc(J, c) : "";
  n = {"%c":"%a %b %d %H:%M:%S %Y", "%D":"%m/%d/%y", "%F":"%Y-%m-%d", "%h":"%b", "%r":"%I:%M:%S %p", "%R":"%H:%M", "%T":"%H:%M:%S", "%x":"%m/%d/%y", "%X":"%H:%M:%S", "%Ec":"%c", "%EC":"%C", "%Ex":"%m/%d/%y", "%EX":"%H:%M:%S", "%Ey":"%y", "%EY":"%Y", "%Od":"%d", "%Oe":"%e", "%OH":"%H", "%OI":"%I", "%Om":"%m", "%OM":"%M", "%OS":"%S", "%Ou":"%u", "%OU":"%U", "%OV":"%V", "%Ow":"%w", "%OW":"%W", "%Oy":"%y",};
  for (var r in n) {
    c = c.replace(new RegExp(r, "g"), n[r]);
  }
  var w = "Sunday Monday Tuesday Wednesday Thursday Friday Saturday".split(" "), z = "January February March April May June July August September October November December".split(" ");
  n = {"%a":g => w[g.F].substring(0, 3), "%A":g => w[g.F], "%b":g => z[g.$].substring(0, 3), "%B":g => z[g.$], "%C":g => f((g.K + 1900) / 100 | 0, 2), "%d":g => f(g.ha, 2), "%e":g => e(g.ha, 2, " "), "%g":g => l(g).toString().substring(2), "%G":l, "%H":g => f(g.Z, 2), "%I":g => {
    g = g.Z;
    0 == g ? g = 12 : 12 < g && (g -= 12);
    return f(g, 2);
  }, "%j":g => {
    for (var t = 0, q = 0; q <= g.$ - 1; t += (Lc(g.K + 1900) ? Mc : Nc)[q++]) {
    }
    return f(g.ha + t, 3);
  }, "%m":g => f(g.$ + 1, 2), "%M":g => f(g.ib, 2), "%n":() => "\n", "%p":g => 0 <= g.Z && 12 > g.Z ? "AM" : "PM", "%S":g => f(g.jb, 2), "%t":() => "\t", "%u":g => g.F || 7, "%U":g => f(Math.floor((g.J + 7 - g.F) / 7), 2), "%V":g => {
    var t = Math.floor((g.J + 7 - (g.F + 6) % 7) / 7);
    2 >= (g.F + 371 - g.J - 2) % 7 && t++;
    if (t) {
      53 == t && (q = (g.F + 371 - g.J) % 7, 4 == q || 3 == q && Lc(g.K) || (t = 1));
    } else {
      t = 52;
      var q = (g.F + 7 - g.J - 1) % 7;
      (4 == q || 5 == q && Lc(g.K % 400 - 1)) && t++;
    }
    return f(t, 2);
  }, "%w":g => g.F, "%W":g => f(Math.floor((g.J + 7 - (g.F + 6) % 7) / 7), 2), "%y":g => (g.K + 1900).toString().substring(2), "%Y":g => g.K + 1900, "%z":g => {
    g = g.hb;
    var t = 0 <= g;
    g = Math.abs(g) / 60;
    return (t ? "+" : "-") + String("0000" + (g / 60 * 100 + g % 60)).slice(-4);
  }, "%Z":g => g.kb, "%%":() => "%"};
  c = c.replace(/%%/g, "\x00\x00");
  for (r in n) {
    c.includes(r) && (c = c.replace(new RegExp(r, "g"), n[r](d)));
  }
  c = c.replace(/\0\0/g, "%");
  r = Oc(c);
  if (r.length > a) {
    return 0;
  }
  Ea.set(r, b);
  return r.length - 1;
};
O = k.BindingError = class extends Error {
  constructor(b) {
    super(b);
    this.name = "BindingError";
  }
};
N.push(0, 1, void 0, 1, null, 1, !0, 1, !1, 1,);
k.count_emval_handles = () => N.length / 2 - 5 - ab.length;
db = k.PureVirtualError = cb("PureVirtualError");
for (var Qc = Array(256), Rc = 0; 256 > Rc; ++Rc) {
  Qc[Rc] = String.fromCharCode(Rc);
}
eb = Qc;
k.getInheritedInstanceCount = () => Object.keys(ib).length;
k.getLiveInheritedInstances = () => {
  var b = [], a;
  for (a in ib) {
    ib.hasOwnProperty(a) && b.push(ib[a]);
  }
  return b;
};
k.flushPendingDeletes = gb;
k.setDelayFunction = b => {
  hb = b;
  fb.length && hb && hb(gb);
};
zb = k.InternalError = class extends Error {
  constructor(b) {
    super(b);
    this.name = "InternalError";
  }
};
Object.assign(Kb.prototype, {isAliasOf:function(b) {
  if (!(this instanceof Kb && b instanceof Kb)) {
    return !1;
  }
  var a = this.g.j.h, c = this.g.i;
  b.g = b.g;
  var d = b.g.j.h;
  for (b = b.g.i; a.o;) {
    c = a.S(c), a = a.o;
  }
  for (; d.o;) {
    b = d.S(b), d = d.o;
  }
  return a === d && c === b;
}, clone:function() {
  this.g.i || Jb(this);
  if (this.g.O) {
    return this.g.count.value += 1, this;
  }
  var b = Ab, a = Object, c = a.create, d = Object.getPrototypeOf(this), e = this.g;
  b = b(c.call(a, d, {g:{value:{count:e.count, M:e.M, O:e.O, i:e.i, j:e.j, s:e.s, A:e.A,},}}));
  b.g.count.value += 1;
  b.g.M = !1;
  return b;
}, ["delete"]() {
  this.g.i || Jb(this);
  if (this.g.M && !this.g.O) {
    throw new O("Object already scheduled for deletion");
  }
  pb(this);
  var b = this.g;
  --b.count.value;
  0 === b.count.value && (b.s ? b.A.D(b.s) : b.j.h.D(b.i));
  this.g.O || (this.g.s = void 0, this.g.i = void 0);
}, isDeleted:function() {
  return !this.g.i;
}, deleteLater:function() {
  this.g.i || Jb(this);
  if (this.g.M && !this.g.O) {
    throw new O("Object already scheduled for deletion");
  }
  fb.push(this);
  1 === fb.length && hb && hb(gb);
  this.g.M = !0;
  return this;
},});
Object.assign(Ub.prototype, {Ra(b) {
  this.xa && (b = this.xa(b));
  return b;
}, pa(b) {
  this.D?.(b);
}, argPackAdvance:8, readValueFromPointer:Eb, fromWireType:function(b) {
  function a() {
    return this.V ? Bb(this.h.C, {j:this.ab, i:c, A:this, s:b,}) : Bb(this.h.C, {j:this, i:b,});
  }
  var c = this.Ra(b);
  if (!c) {
    return this.pa(b), null;
  }
  var d = tb(this.h, c);
  if (void 0 !== d) {
    if (0 === d.g.count.value) {
      return d.g.i = c, d.g.s = b, d.clone();
    }
    d = d.clone();
    this.pa(b);
    return d;
  }
  d = this.h.Qa(c);
  d = sb[d];
  if (!d) {
    return a.call(this);
  }
  d = this.U ? d.Ha : d.pointerType;
  var e = rb(c, this.h, d.h);
  return null === e ? a.call(this) : this.V ? Bb(d.h.C, {j:d, i:e, A:this, s:b,}) : Bb(d.h.C, {j:d, i:e,});
},});
ac = k.UnboundTypeError = cb("UnboundTypeError");
var Tc = {_abort_js:() => {
  Ra("");
}, _embind_create_inheriting_constructor:(b, a, c) => {
  b = S(b);
  a = ob(a, "wrapper");
  c = R(c);
  var d = a.h, e = d.C, f = d.o.C, m = d.o.constructor;
  b = $a(b, function(...h) {
    d.o.wa.forEach(function(l) {
      if (this[l] === f[l]) {
        throw new db(`Pure virtual function ${l} must be implemented in JavaScript`);
      }
    }.bind(this));
    Object.defineProperty(this, "__parent", {value:e});
    this.__construct(...h);
  });
  e.__construct = function(...h) {
    if (this === e) {
      throw new O("Pass correct 'this' to __construct");
    }
    h = m.implement(this, ...h);
    pb(h);
    var l = h.g;
    h.notifyOnDestruction();
    l.O = !0;
    Object.defineProperties(this, {g:{value:l}});
    Ab(this);
    h = l.i;
    h = jb(d, h);
    if (ib.hasOwnProperty(h)) {
      throw new O(`Tried to register registered instance: ${h}`);
    }
    ib[h] = this;
  };
  e.__destruct = function() {
    if (this === e) {
      throw new O("Pass correct 'this' to __destruct");
    }
    pb(this);
    var h = this.g.i;
    h = jb(d, h);
    if (ib.hasOwnProperty(h)) {
      delete ib[h];
    } else {
      throw new O(`Tried to unregister unregistered instance: ${h}`);
    }
  };
  b.prototype = Object.create(e);
  Object.assign(b.prototype, c);
  return bb(b);
}, _embind_finalize_value_object:b => {
  var a = Cb[b];
  delete Cb[b];
  var c = a.fa, d = a.D, e = a.sa, f = e.map(m => m.Ua).concat(e.map(m => m.eb));
  X([b], f, m => {
    var h = {};
    e.forEach((l, n) => {
      var r = m[n], w = l.Sa, z = l.Ta, g = m[n + e.length], t = l.cb, q = l.fb;
      h[l.Oa] = {read:G => r.fromWireType(w(z, G)), write:(G, F) => {
        var v = [];
        t(q, G, g.toWireType(v, F));
        Db(v);
      }};
    });
    return [{name:a.name, fromWireType:l => {
      var n = {}, r;
      for (r in h) {
        n[r] = h[r].read(l);
      }
      d(l);
      return n;
    }, toWireType:(l, n) => {
      for (var r in h) {
        if (!(r in n)) {
          throw new TypeError(`Missing field: "${r}"`);
        }
      }
      var w = c();
      for (r in h) {
        h[r].write(w, n[r]);
      }
      null !== l && l.push(d, w);
      return w;
    }, argPackAdvance:8, readValueFromPointer:Eb, B:d,}];
  });
}, _embind_register_bigint:() => {
}, _embind_register_bool:(b, a, c, d) => {
  a = S(a);
  Hb(b, {name:a, fromWireType:function(e) {
    return !!e;
  }, toWireType:function(e, f) {
    return f ? c : d;
  }, argPackAdvance:8, readValueFromPointer:function(e) {
    return this.fromWireType(J[e]);
  }, B:null,});
}, _embind_register_class:(b, a, c, d, e, f, m, h, l, n, r, w, z) => {
  r = S(r);
  f = Y(e, f);
  h &&= Y(m, h);
  n &&= Y(l, n);
  z = Y(w, z);
  var g = Nb(r);
  Mb(g, function() {
    bc(`Cannot construct ${r} due to unbound types`, [d]);
  });
  X([b, a, c], d ? [d] : [], t => {
    t = t[0];
    if (d) {
      var q = t.h;
      var G = q.C;
    } else {
      G = Kb.prototype;
    }
    t = $a(r, function(...L) {
      if (Object.getPrototypeOf(this) !== F) {
        throw new O("Use 'new' to construct " + r);
      }
      if (void 0 === v.I) {
        throw new O(r + " has no accessible constructor");
      }
      var Q = v.I[L.length];
      if (void 0 === Q) {
        throw new O(`Tried to invoke ctor of ${r} with invalid number of parameters (${L.length}) - expected (${Object.keys(v.I).toString()}) parameters instead!`);
      }
      return Q.apply(this, L);
    });
    var F = Object.create(G, {constructor:{value:t},});
    t.prototype = F;
    var v = new Ob(r, t, F, z, q, f, h, n);
    if (v.o) {
      var H;
      (H = v.o).T ?? (H.T = []);
      v.o.T.push(v);
    }
    q = new Ub(r, v, !0, !1, !1);
    H = new Ub(r + "*", v, !1, !1, !1);
    G = new Ub(r + " const*", v, !1, !0, !1);
    sb[b] = {pointerType:H, Ha:G};
    Vb(g, t);
    return [q, H, G];
  });
}, _embind_register_class_class_function:(b, a, c, d, e, f, m) => {
  var h = ec(c, d);
  a = S(a);
  a = fc(a);
  f = Y(e, f);
  X([], [b], l => {
    function n() {
      bc(`Cannot call ${r} due to unbound types`, h);
    }
    l = l[0];
    var r = `${l.name}.${a}`;
    a.startsWith("@@") && (a = Symbol[a.substring(2)]);
    var w = l.h.constructor;
    void 0 === w[a] ? (n.L = c - 1, w[a] = n) : (Lb(w, a, r), w[a].l[c - 1] = n);
    X([], h, z => {
      z = dc(r, [z[0], null].concat(z.slice(1)), null, f, m);
      void 0 === w[a].l ? (z.L = c - 1, w[a] = z) : w[a].l[c - 1] = z;
      if (l.h.T) {
        for (const g of l.h.T) {
          g.constructor.hasOwnProperty(a) || (g.constructor[a] = z);
        }
      }
      return [];
    });
    return [];
  });
}, _embind_register_class_class_property:(b, a, c, d, e, f, m, h) => {
  a = S(a);
  f = Y(e, f);
  X([], [b], l => {
    l = l[0];
    var n = `${l.name}.${a}`, r = {get() {
      bc(`Cannot access ${n} due to unbound types`, [c]);
    }, enumerable:!0, configurable:!0};
    r.set = h ? () => {
      bc(`Cannot access ${n} due to unbound types`, [c]);
    } : () => {
      throw new O(`${n} is a read-only property`);
    };
    Object.defineProperty(l.h.constructor, a, r);
    X([], [c], w => {
      w = w[0];
      var z = {get() {
        return w.fromWireType(f(d));
      }, enumerable:!0};
      h && (h = Y(m, h), z.set = g => {
        var t = [];
        h(d, w.toWireType(t, g));
        Db(t);
      });
      Object.defineProperty(l.h.constructor, a, z);
      return [];
    });
    return [];
  });
}, _embind_register_class_constructor:(b, a, c, d, e, f) => {
  var m = ec(a, c);
  e = Y(d, e);
  X([], [b], h => {
    h = h[0];
    var l = `constructor ${h.name}`;
    void 0 === h.h.I && (h.h.I = []);
    if (void 0 !== h.h.I[a - 1]) {
      throw new O(`Cannot register multiple constructors with identical number of parameters (${a - 1}) for class '${h.name}'! Overload resolution is currently only performed using the parameter count, not actual type info!`);
    }
    h.h.I[a - 1] = () => {
      bc(`Cannot construct ${h.name} due to unbound types`, m);
    };
    X([], m, n => {
      n.splice(1, 0, null);
      h.h.I[a - 1] = dc(l, n, null, e, f);
      return [];
    });
    return [];
  });
}, _embind_register_class_function:(b, a, c, d, e, f, m, h) => {
  var l = ec(c, d);
  a = S(a);
  a = fc(a);
  f = Y(e, f);
  X([], [b], n => {
    function r() {
      bc(`Cannot call ${w} due to unbound types`, l);
    }
    n = n[0];
    var w = `${n.name}.${a}`;
    a.startsWith("@@") && (a = Symbol[a.substring(2)]);
    h && n.h.wa.push(a);
    var z = n.h.C, g = z[a];
    void 0 === g || void 0 === g.l && g.className !== n.name && g.L === c - 2 ? (r.L = c - 2, r.className = n.name, z[a] = r) : (Lb(z, a, w), z[a].l[c - 2] = r);
    X([], l, t => {
      t = dc(w, t, n, f, m);
      void 0 === z[a].l ? (t.L = c - 2, z[a] = t) : z[a].l[c - 2] = t;
      return [];
    });
    return [];
  });
}, _embind_register_class_property:(b, a, c, d, e, f, m, h, l, n) => {
  a = S(a);
  e = Y(d, e);
  X([], [b], r => {
    r = r[0];
    var w = `${r.name}.${a}`, z = {get() {
      bc(`Cannot access ${w} due to unbound types`, [c, m]);
    }, enumerable:!0, configurable:!0};
    z.set = l ? () => bc(`Cannot access ${w} due to unbound types`, [c, m]) : () => {
      throw new O(w + " is a read-only property");
    };
    Object.defineProperty(r.h.C, a, z);
    X([], l ? [c, m] : [c], g => {
      var t = g[0], q = {get() {
        var F = gc(this, r, w + " getter");
        return t.fromWireType(e(f, F));
      }, enumerable:!0};
      if (l) {
        l = Y(h, l);
        var G = g[1];
        q.set = function(F) {
          var v = gc(this, r, w + " setter"), H = [];
          l(n, v, G.toWireType(H, F));
          Db(H);
        };
      }
      Object.defineProperty(r.h.C, a, q);
      return [];
    });
    return [];
  });
}, _embind_register_emval:b => Hb(b, ic), _embind_register_enum:(b, a, c, d) => {
  function e() {
  }
  a = S(a);
  e.values = {};
  Hb(b, {name:a, constructor:e, fromWireType:function(f) {
    return this.constructor.values[f];
  }, toWireType:(f, m) => m.value, argPackAdvance:8, readValueFromPointer:jc(a, c, d), B:null,});
  Mb(a, e);
}, _embind_register_enum_value:(b, a, c) => {
  var d = ob(b, "enum");
  a = S(a);
  b = d.constructor;
  d = Object.create(d.constructor.prototype, {value:{value:c}, constructor:{value:$a(`${d.name}_${a}`, function() {
  })},});
  b.values[c] = d;
  b[a] = d;
}, _embind_register_float:(b, a, c) => {
  a = S(a);
  Hb(b, {name:a, fromWireType:d => d, toWireType:(d, e) => e, argPackAdvance:8, readValueFromPointer:kc(a, c), B:null,});
}, _embind_register_function:(b, a, c, d, e, f) => {
  var m = ec(a, c);
  b = S(b);
  b = fc(b);
  e = Y(d, e);
  Mb(b, function() {
    bc(`Cannot call ${b} due to unbound types`, m);
  }, a - 1);
  X([], m, h => {
    Vb(b, dc(b, [h[0], null].concat(h.slice(1)), null, e, f), a - 1);
    return [];
  });
}, _embind_register_integer:(b, a, c, d, e) => {
  a = S(a);
  -1 === e && (e = 4294967295);
  e = h => h;
  if (0 === d) {
    var f = 32 - 8 * c;
    e = h => h << f >>> f;
  }
  var m = a.includes("unsigned") ? function(h, l) {
    return l >>> 0;
  } : function(h, l) {
    return l;
  };
  Hb(b, {name:a, fromWireType:e, toWireType:m, argPackAdvance:8, readValueFromPointer:lc(a, c, 0 !== d), B:null,});
}, _embind_register_memory_view:(b, a, c) => {
  function d(f) {
    return new e(Ea.buffer, M[f + 4 >> 2], M[f >> 2]);
  }
  var e = [Int8Array, Uint8Array, Int16Array, Uint16Array, Int32Array, Uint32Array, Float32Array, Float64Array,][a];
  c = S(c);
  Hb(b, {name:c, fromWireType:d, argPackAdvance:8, readValueFromPointer:d,}, {Va:!0,});
}, _embind_register_std_string:(b, a) => {
  a = S(a);
  var c = "std::string" === a;
  Hb(b, {name:a, fromWireType:function(d) {
    var e = M[d >> 2], f = d + 4;
    if (c) {
      for (var m = f, h = 0; h <= e; ++h) {
        var l = f + h;
        if (h == e || 0 == J[l]) {
          m = m ? sc(J, m, l - m) : "";
          if (void 0 === n) {
            var n = m;
          } else {
            n += String.fromCharCode(0), n += m;
          }
          m = l + 1;
        }
      }
    } else {
      n = Array(e);
      for (h = 0; h < e; ++h) {
        n[h] = String.fromCharCode(J[f + h]);
      }
      n = n.join("");
    }
    mb(d);
    return n;
  }, toWireType:function(d, e) {
    e instanceof ArrayBuffer && (e = new Uint8Array(e));
    var f = "string" == typeof e;
    if (!(f || e instanceof Uint8Array || e instanceof Uint8ClampedArray || e instanceof Int8Array)) {
      throw new O("Cannot pass non-string to std::string");
    }
    var m = c && f ? nc(e) : e.length;
    var h = Sc(4 + m + 1), l = h + 4;
    M[h >> 2] = m;
    if (c && f) {
      mc(e, J, l, m + 1);
    } else {
      if (f) {
        for (f = 0; f < m; ++f) {
          var n = e.charCodeAt(f);
          if (255 < n) {
            throw mb(l), new O("String has UTF-16 code units that do not fit in 8 bits");
          }
          J[l + f] = n;
        }
      } else {
        for (f = 0; f < m; ++f) {
          J[l + f] = e[f];
        }
      }
    }
    null !== d && d.push(mb, h);
    return h;
  }, argPackAdvance:8, readValueFromPointer:Eb, B(d) {
    mb(d);
  },});
}, _embind_register_std_wstring:(b, a, c) => {
  c = S(c);
  if (2 === a) {
    var d = uc;
    var e = vc;
    var f = wc;
    var m = h => Ga[h >> 1];
  } else {
    4 === a && (d = xc, e = yc, f = zc, m = h => M[h >> 2]);
  }
  Hb(b, {name:c, fromWireType:h => {
    for (var l = M[h >> 2], n, r = h + 4, w = 0; w <= l; ++w) {
      var z = h + 4 + w * a;
      if (w == l || 0 == m(z)) {
        r = d(r, z - r), void 0 === n ? n = r : (n += String.fromCharCode(0), n += r), r = z + a;
      }
    }
    mb(h);
    return n;
  }, toWireType:(h, l) => {
    if ("string" != typeof l) {
      throw new O(`Cannot pass non-string to C++ string type ${c}`);
    }
    var n = f(l), r = Sc(4 + n + a);
    M[r >> 2] = n / a;
    e(l, r + 4, n + a);
    null !== h && h.push(mb, r);
    return r;
  }, argPackAdvance:8, readValueFromPointer:Eb, B(h) {
    mb(h);
  }});
}, _embind_register_value_object:(b, a, c, d, e, f) => {
  Cb[b] = {name:S(a), fa:Y(c, d), D:Y(e, f), sa:[],};
}, _embind_register_value_object_field:(b, a, c, d, e, f, m, h, l, n) => {
  Cb[b].sa.push({Oa:S(a), Ua:c, Sa:Y(d, e), Ta:f, eb:m, cb:Y(h, l), fb:n,});
}, _embind_register_void:(b, a) => {
  a = S(a);
  Hb(b, {mb:!0, name:a, argPackAdvance:0, fromWireType:() => {
  }, toWireType:() => {
  },});
}, _emscripten_get_now_is_monotonic:() => 1, _emscripten_memcpy_js:(b, a, c) => J.copyWithin(b, a, a + c), _emval_as:(b, a, c) => {
  b = R(b);
  a = ob(a, "emval::as");
  return Ac(a, c, b);
}, _emval_call_method:(b, a, c, d, e) => {
  b = Dc[b];
  a = R(a);
  c = Cc(c);
  return b(a, a[c], d, e);
}, _emval_decref:hc, _emval_get_method_caller:(b, a, c) => {
  var d = Fc(b, a), e = d.shift();
  b--;
  var f = Array(b);
  a = `methodCaller<(${d.map(m => m.name).join(", ")}) => ${e.name}>`;
  return Ec($a(a, (m, h, l, n) => {
    for (var r = 0, w = 0; w < b; ++w) {
      f[w] = d[w].readValueFromPointer(n + r), r += d[w].argPackAdvance;
    }
    m = 1 === c ? Gc(h, f) : h.apply(m, f);
    return Ac(e, l, m);
  }));
}, _emval_get_module_property:b => {
  b = Cc(b);
  return bb(k[b]);
}, _emval_get_property:(b, a) => {
  b = R(b);
  a = R(a);
  return bb(b[a]);
}, _emval_incref:b => {
  9 < b && (N[b + 1] += 1);
}, _emval_new_array:() => bb([]), _emval_new_cstring:b => bb(Cc(b)), _emval_new_object:() => bb({}), _emval_run_destructors:b => {
  var a = R(b);
  Db(a);
  hc(b);
}, _emval_set_property:(b, a, c) => {
  b = R(b);
  a = R(a);
  c = R(c);
  b[a] = c;
}, _emval_take_value:(b, a) => {
  b = ob(b, "_emval_take_value");
  b = b.readValueFromPointer(a);
  return bb(b);
}, emscripten_date_now:() => Date.now(), emscripten_get_now:() => performance.now(), emscripten_resize_heap:b => {
  var a = J.length;
  b >>>= 0;
  if (2147483648 < b) {
    return !1;
  }
  for (var c = 1; 4 >= c; c *= 2) {
    var d = a * (1 + 0.2 / c);
    d = Math.min(d, b + 100663296);
    var e = Math;
    d = Math.max(b, d);
    a: {
      e = (e.min.call(e, 2147483648, d + (65536 - d % 65536) % 65536) - Ca.buffer.byteLength + 65535) / 65536;
      try {
        Ca.grow(e);
        Ja();
        var f = 1;
        break a;
      } catch (m) {
      }
      f = void 0;
    }
    if (f) {
      return !0;
    }
  }
  return !1;
}, environ_get:(b, a) => {
  var c = 0;
  Jc().forEach((d, e) => {
    var f = a + c;
    e = M[b + 4 * e >> 2] = f;
    for (f = 0; f < d.length; ++f) {
      Ea[e++] = d.charCodeAt(f);
    }
    Ea[e] = 0;
    c += d.length + 1;
  });
  return 0;
}, environ_sizes_get:(b, a) => {
  var c = Jc();
  M[b >> 2] = c.length;
  var d = 0;
  c.forEach(e => d += e.length + 1);
  M[a >> 2] = d;
  return 0;
}, fd_close:() => 52, fd_seek:function() {
  return 70;
}, fd_write:(b, a, c, d) => {
  for (var e = 0, f = 0; f < c; f++) {
    var m = M[a >> 2], h = M[a + 4 >> 2];
    a += 8;
    for (var l = 0; l < h; l++) {
      var n = J[m + l], r = Kc[b];
      0 === n || 10 === n ? ((1 === b ? za : Aa)(sc(r, 0)), r.length = 0) : r.push(n);
    }
    e += h;
  }
  M[d >> 2] = e;
  return 0;
}, strftime_l:(b, a, c, d) => Pc(b, a, c, d)}, Z = function() {
  function b(c) {
    Z = c.exports;
    Ca = Z.memory;
    Ja();
    Xb = Z.__indirect_function_table;
    La.unshift(Z.__wasm_call_ctors);
    Oa--;
    k.monitorRunDependencies?.(Oa);
    0 == Oa && (null !== Pa && (clearInterval(Pa), Pa = null), Qa && (c = Qa, Qa = null, c()));
    return Z;
  }
  var a = {env:Tc, wasi_snapshot_preview1:Tc,};
  Oa++;
  k.monitorRunDependencies?.(Oa);
  if (k.instantiateWasm) {
    try {
      return k.instantiateWasm(a, b);
    } catch (c) {
      Aa(`Module.instantiateWasm callback failed with error: ${c}`), ba(c);
    }
  }
  Ta ||= Sa("canvas_advanced.wasm") ? "canvas_advanced.wasm" : k.locateFile ? k.locateFile("canvas_advanced.wasm", y) : y + "canvas_advanced.wasm";
  Xa(a, function(c) {
    b(c.instance);
  }).catch(ba);
  return {};
}(), mb = b => (mb = Z.free)(b), Sc = b => (Sc = Z.malloc)(b), lb = b => (lb = Z.__getTypeName)(b);
k.dynCall_jiji = (b, a, c, d, e) => (k.dynCall_jiji = Z.dynCall_jiji)(b, a, c, d, e);
k.dynCall_viijii = (b, a, c, d, e, f, m) => (k.dynCall_viijii = Z.dynCall_viijii)(b, a, c, d, e, f, m);
k.dynCall_iiiiij = (b, a, c, d, e, f, m) => (k.dynCall_iiiiij = Z.dynCall_iiiiij)(b, a, c, d, e, f, m);
k.dynCall_iiiiijj = (b, a, c, d, e, f, m, h, l) => (k.dynCall_iiiiijj = Z.dynCall_iiiiijj)(b, a, c, d, e, f, m, h, l);
k.dynCall_iiiiiijj = (b, a, c, d, e, f, m, h, l, n) => (k.dynCall_iiiiiijj = Z.dynCall_iiiiiijj)(b, a, c, d, e, f, m, h, l, n);
var Uc;
Qa = function Vc() {
  Uc || Wc();
  Uc || (Qa = Vc);
};
function Wc() {
  function b() {
    if (!Uc && (Uc = !0, k.calledRun = !0, !Da)) {
      Za(La);
      aa(k);
      if (k.onRuntimeInitialized) {
        k.onRuntimeInitialized();
      }
      if (k.postRun) {
        for ("function" == typeof k.postRun && (k.postRun = [k.postRun]); k.postRun.length;) {
          var a = k.postRun.shift();
          Ma.unshift(a);
        }
      }
      Za(Ma);
    }
  }
  if (!(0 < Oa)) {
    if (k.preRun) {
      for ("function" == typeof k.preRun && (k.preRun = [k.preRun]); k.preRun.length;) {
        Na();
      }
    }
    Za(Ka);
    0 < Oa || (k.setStatus ? (k.setStatus("Running..."), setTimeout(function() {
      setTimeout(function() {
        k.setStatus("");
      }, 1);
      b();
    }, 1)) : b());
  }
}
if (k.preInit) {
  for ("function" == typeof k.preInit && (k.preInit = [k.preInit]); 0 < k.preInit.length;) {
    k.preInit.pop()();
  }
}
Wc();
moduleRtn = da;



  return moduleRtn;
}
);
})();
export default Rive;
